import React, { useEffect, useState } from 'react';
// import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import MicIcon from '@material-ui/icons/Mic';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { resetData } from 'redux/actions/FinancialModelActions';
import QuestRespContainer from './QuestRespContainer';
import MeetingRequestModal from './MeetingRequestModal';

const data = [
  {
    question: 'How are any current intellectual assets owned ?',
    answer:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. At cumque doloremque molestias inventore repellat soluta, voluptate facere atque quis placeat dolores, eligendi dignissimos debitis minus iste quasi. Ratione ut dolorem consectetur provident tenetur doloremque, aperiam asperiores incidunt reiciendis quisquam facere at, atque expedita, error voluptatem sunt reprehenderit assumenda dignissimos soluta distinctio libero repellendus! Fugiat id veritatis ipsa magnam repellat voluptatem, ut minima nisi magni. Fugit laudantium, libero enim hic illum natus voluptas iusto, reiciendis maxime, tempore doloremque beatae ab odit optio voluptate. Iusto ut eligendi magnam dignissimos dicta temporibus, nam nobis excepturi corrupti. Quasi provident quo veniam ex eum fugiat.'
  },
  {
    question: 'What are your strengths and advantages overs your competitors ?',
    answer:
      'voluptate facere atque quis placeat dolores, eligendi dignissimos debitis minus iste quasi. Ratione ut dolorem consectetur provident tenetur doloremque, aperiam asperiores incidunt reiciendis quisquam facere at, atque expedita, error voluptatem sunt reprehenderit assumenda dignissimos soluta distinctio libero repellendus! Fugiat id veritatis ipsa magnam repellat voluptatem, ut minima nisi magni. Fugit laudantium, libero enim hic illum natus voluptas iusto, reiciendis maxime, tempore doloremque beatae ab odit optio voluptate. Iusto ut eligendi magnam dignissimos dicta temporibus, nam nobis excepturi corrupti. Quasi provident quo veniam ex eum fugiat.'
  },
  {
    question: 'How much is your marketing budget ?',
    answer:
      'At cumque doloremque molestias inventore repellat soluta, voluptate facere atque quis placeat dolores, eligendi dignissimos debitis minus iste quasi. Ratione ut dolorem consectetur provident tenetur doloremque, aperiam asperiores incidunt reiciendis quisquam facere at, atque expedita, error voluptatem sunt reprehenderit assumenda dignissimos soluta distinctio libero repellendus! Fugiat id veritatis ipsa magnam repellat voluptatem, ut minima nisi magni. Fugit laudantium, libero enim hic illum natus voluptas iusto, reiciendis maxime, tempore doloremque beatae ab odit optio voluptate. Iusto ut eligendi magnam dignissimos dicta temporibus, nam nobis excepturi corrupti. Quasi provident quo veniam ex eum fugiat.'
  },
  {
    question: 'What are your per customer acquisition costs ?',
    answer:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. At cumque doloremque molestias inventore repellat soluta, voluptate facere atque quis placeat dolores, eligendi dignissimos debitis minus iste quasi. Ratione ut dolorem consectetur provident tenetur doloremque, aperiam asperiores incidunt reiciendis quisquam facere at, atque expedita, error voluptatem sunt reprehenderit assumenda dignissimos soluta distinctio libero repellendus! Fugiat id veritatis ipsa magnam repellat voluptatem, ut minima nisi magni. Fugit laudantium, libero enim hic illum natus voluptas iusto, reiciendis maxime, tempore doloremque beatae ab odit optio voluptate. Iusto ut eligendi magnam dignissimos dicta temporibus, nam nobis excepturi corrupti. Quasi provident quo veniam ex eum fugiat.'
  },
  {
    question: 'How long will it take to become profitable ?',
    answer:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Atque expedita, error voluptatem sunt reprehenderit assumenda dignissimos soluta distinctio libero repellendus! Fugiat id veritatis ipsa magnam repellat voluptatem, ut minima nisi magni. Fugit laudantium, libero enim hic illum natus voluptas iusto, reiciendis maxime, tempore doloremque beatae ab odit optio voluptate. Iusto ut eligendi magnam dignissimos dicta temporibus, nam nobis excepturi corrupti. Quasi provident quo veniam ex eum fugiat.'
  }
];

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    textAlign: 'center',
    margin: '20px auto'
  },
  valueInfo: {
    marginBottom: '2.5rem'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  }
}));

const Discuss = (props) => {
  const dispatch = useDispatch();
  const [comments, setComments] = useState('');
  const [showRequestModal, setShowRequestModal] = useState(false);
  const classes = useStyles();

  const handleChangeAddComments = (e) => {
    setComments(e.target.value);
  };

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  return (
    <div>
      <MeetingRequestModal
        onClose={() => setShowRequestModal(false)}
        open={showRequestModal}
      />
      <div className={classes.header}>
        <h1 className={classes.title}>Ask the Issuer</h1>
        <Button
          color="primary"
          onClick={() => setShowRequestModal(true)}
          variant="contained">
          Request a meeting
        </Button>
      </div>
      <div className={classes.valueInfo}>
        <FormControl className={classes.textField} variant="outlined">
          <OutlinedInput
            endAdornment={
              <InputAdornment position="end">
                <MicIcon />
              </InputAdornment>
            }
            id="outlined-adornment-valuation"
            inputProps={{
              'aria-label': 'influence'
            }}
            labelWidth={0}
            multiline
            onChange={(e) => handleChangeAddComments(e)}
            placeholder="Please type here"
            rows={4}
            rowsMax={4}
            value={comments}
          />
        </FormControl>
      </div>
      {data.map((val) => (
        <QuestRespContainer answer={val.answer} question={val.question} />
      ))}
    </div>
  );
};

export default withRouter(Discuss);
